import arrayMutators from 'final-form-arrays';
import React, { useState, useEffect } from 'react';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { required, emailFormatValid, composeValidators } from '../../util/validators';

import { useIntl } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import { H3, Page, Button, FieldTextInput, LayoutSideNavigation, LayoutSingleColumn, PrimaryButton } from '../../components';
import css from './ContactUsPage.module.css';
import { post } from '../../util/api';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

//console.log(RECAPTCHA_SITE_KEY);

const ContactUsPage = props => {
  const [submitting, setSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  /*
  const [recaptchaError, setRecaptchaError] = useState(false);

  useEffect(() => {
    if (!document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.grecaptcha) {
        window.grecaptcha.render('recaptcha', {
          sitekey: RECAPTCHA_SITE_KEY,
        });
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);
*/
  const onSubmit = values => {
    /*
    const recaptchaResponse = document.getElementById('g-recaptcha-response').value;

    if (!recaptchaResponse) {
      setRecaptchaError(true);
      return;
    }
*/
    const requestOptions = {
      subject: "New contact form submitted",
      text: `<p>Form details</p>
          <p>Name: ${values.name}</p>
          <p>Email: ${values.email.trim()}</p>
          <p>Message: ${values.message}</p>`,
      //recaptchaResponse,
    };

    setSubmitting(true);
    post('/api/send-operator-email', requestOptions)
      .then(response => {
        setIsSubmitted(true);
        setSubmitting(false);
      })
      .catch(e => {
        setSubmitting(false);
      });
  };

  const { scrollingDisabled } = props;

  const config = useConfiguration();
  const intl = useIntl();

  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'ContactUsPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'ContactUsPage.schemaDescription' });

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      description={schemaDescription}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
          </>
        }
        sideNav={null}
        currentPage="ContactUsPage"
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <div className={css.content}>
            <H3 as="h1">
              <FormattedMessage id="ContactUsPage.heading" defaultMessage="Contact Us" />
            </H3>
            {isSubmitted ? (
              <div className={css.thankYouMessage}>
                <FormattedMessage id="ContactUsPage.thankYou" defaultMessage="Thank you for contacting us!" />
              </div>
            ) : (
              <div className={css.form}>
                <FinalForm
                  onSubmit={onSubmit}
                  mutators={{ ...arrayMutators }}
                  render={({ handleSubmit, form, submitting, pristine }) => (
                    <form
                      onSubmit={e => {
                        e.preventDefault();
                        handleSubmit(e);
                      }}
                      className={css.form}
                    >
                      <FormSpy onChange={() => { }} />
                      <FieldTextInput
                        className={css.field}
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Your name"
                        validate={required('Name is required')}
                      />
                      <br />
                      <FieldTextInput
                        className={css.field}
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Your email"
                        validate={composeValidators(required('Email is required'), emailFormatValid('Invalid email address'))}
                      />
                      <br />
                      <FieldTextInput
                        className={css.field}
                        type="textarea"
                        id="message"
                        name="message"
                        placeholder="Your message"
                        validate={required('Message is required')}
                      />
                      <br />

                      {/* <div className={css.recaptchaContainer}>
                        <div id="recaptcha"></div>
                        {recaptchaError && (
                          <div className={css.errorMessage}>
                            <FormattedMessage id="ContactUsPage.recaptchaError" defaultMessage="Please complete the CAPTCHA." />
                          </div>
                        )}
                      </div>

                      <br /> */}
                      <PrimaryButton
                        type="submit"
                        disabled={submitting || pristine}
                        className={css.submitButton}
                        inProgress={submitting}
                      >
                        <FormattedMessage id="ContactUsPage.submit" defaultMessage="Submit" />
                      </PrimaryButton>
                      <br />
                      <br />
                    </form>
                  )}
                />
              </div>
            )}
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactUsPage.propTypes = {
  intl: intlShape.isRequired,
};

export default ContactUsPage;
